import { policyUrl } from './precision';
import instance from './axiosInstance';

const scheduleUrl = `${policyUrl}/schedule`;

function getSchedule(reqBody, options = {}, http = instance) {
  return http.get(scheduleUrl, reqBody, options);
}

function updateSchedule(reqBody, options = {}, http = instance) {
  return http.post(scheduleUrl, reqBody, options);
}

function deleteSchedule(scheduleId, options = {}, http = instance) {
  return http.delete(`${scheduleUrl}/${scheduleId}`, options);
}

function getEmails(http = instance) {
  return http.get(`${scheduleUrl}/emails`);
}

export { getSchedule, updateSchedule, deleteSchedule, getEmails };
